import { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';

const CookieConsent = () => {
  const { language } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem('cookie_consent', 'declined');
    setVisible(false);
  };

  const texts = {
    en: {
      message: 'We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies.',
      accept: 'Accept All',
      decline: 'Essential Only',
      privacy: 'Privacy Policy',
    },
    de: {
      message: 'Wir verwenden Cookies, um Ihre Erfahrung zu verbessern. Durch die weitere Nutzung dieser Website stimmen Sie unserer Verwendung von Cookies zu.',
      accept: 'Alle akzeptieren',
      decline: 'Nur Essentielle',
      privacy: 'Datenschutzerklärung',
    },
    it: {
      message: 'Utilizziamo cookie per migliorare la tua esperienza. Continuando a visitare questo sito accetti il nostro utilizzo dei cookie.',
      accept: 'Accetta Tutti',
      decline: 'Solo Essenziali',
      privacy: 'Informativa sulla Privacy',
    },
  };

  const t = texts[language] || texts.en;

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[60] bg-[#121212] border-t border-[#D4AF37]/30 px-4 py-4 sm:px-6 shadow-2xl animate-in slide-in-from-bottom duration-500"
      data-testid="cookie-consent-banner"
    >
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center gap-4">
        <p className="text-[#A1A1AA] text-sm flex-1">
          {t.message}{' '}
          <Link to="/privacy" className="text-[#D4AF37] underline hover:text-[#C5A059] transition-colors">
            {t.privacy}
          </Link>
        </p>
        <div className="flex items-center gap-3 flex-shrink-0">
          <button
            onClick={decline}
            className="px-5 py-2 border border-white/20 text-white text-sm hover:bg-white/5 transition-colors"
            data-testid="cookie-decline-btn"
          >
            {t.decline}
          </button>
          <button
            onClick={accept}
            className="px-5 py-2 bg-[#D4AF37] text-black text-sm font-semibold hover:bg-[#C5A059] transition-colors"
            data-testid="cookie-accept-btn"
          >
            {t.accept}
          </button>
          <button
            onClick={decline}
            className="text-[#A1A1AA] hover:text-white transition-colors p-1"
            data-testid="cookie-close-btn"
            aria-label="Close"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
